import { Paper } from '@mui/material';
import type React from 'react';

/**
 * {@link DatapadPaper} input props.
 */
export type DatapadPaperProps = React.PropsWithChildren;

/**
 * Root paper (container) used by the datapad. Encapsulates shared styling details.
 */
export function DatapadPaper(props: DatapadPaperProps): React.ReactElement {
	const { children } = props;

	return (
		<Paper
			square
			sx={{
				/*
				 * Using flexbox for a vertical layout container.
				 * This is the root container for the entire datapad UI.
				 */
				display: 'flex',
				flexDirection: 'column',

				/*
				 * Absolute positioning with full width/height fills the parent container.
				 * This ensures the datapad takes up the entire available viewport.
				 */
				position: 'absolute',
				width: '100%',
				height: '100%',
			}}
		>
			{children}
		</Paper>
	);
}
